import { render, staticRenderFns } from "./ConfigCard.vue?vue&type=template&id=7af46ca8"
import script from "./ConfigCard.vue?vue&type=script&lang=js"
export * from "./ConfigCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports